// MeetingType Enum Values:
// 1 = SALE (מכירה)
// 2 = PRE_ADVICE_FIRST (טרום ייעוץ ראשונה)
// 3 = PRE_ADVICE_SECOND (טרום ייעוץ שניה)
// 4 = ANNUAL_FOLLOW_UP (מעקב שנתי)
// 5 = OTHER (אחר)

export enum MeetingType {
  SALE = 1,
  PRE_ADVICE_FIRST = 2,
  PRE_ADVICE_SECOND = 3,
  ANNUAL_FOLLOW_UP = 4,
  OTHER = 5
}

export enum TranscriptFetchStatus {
  PENDING = "PENDING",
  FETCHED = "FETCHED",
  FAILED = "FAILED"
}

export enum ContextSnapshotStatus {
  PENDING = "PENDING",
  COMPLETED = "COMPLETED",
  FAILED = "FAILED"
}

export const ContextSnapshotStatusLabels: Record<ContextSnapshotStatus, string> = {
  [ContextSnapshotStatus.PENDING]: "ממתין",
  [ContextSnapshotStatus.COMPLETED]: "הושלם",
  [ContextSnapshotStatus.FAILED]: "נכשל"
};

export enum Stage0Status {
  PENDING = "PENDING",
  PROCESSING = "PROCESSING",
  COMPLETED = "COMPLETED",
  FAILED = "FAILED"
}

export enum DerivedProcessingStatus {
  PENDING = "PENDING",
  PROCESSING = "PROCESSING",
  COMPLETED = "COMPLETED",
  FAILED = "FAILED"
}

export enum TasksDraftStatus {
  PENDING = "PENDING",
  PROCESSING = "PROCESSING",
  COMPLETED = "COMPLETED",
  FAILED = "FAILED"
}

export interface FirefliesUserData {
  id?: string;
  name?: string;
  email?: string;
}

export interface MeetingExtendedData {
  audio_url?: string;
  video_url?: string;
  participants?: string[]; // רשימת אימיילים של משתתפים
  user?: FirefliesUserData; // המשתמש שיצר את הפגישה ב-Fireflies
  organizer_email?: string;
}

export class Meeting {
    id: number = 0;
    company_id?: number;

    contact_id?: number;
    external_meeting_id?: string;
    participant_email?: string;

    title?: string;

    date_time?: string;
    duration_minutes?: number;

    meeting_type?: number; // MeetingType enum value
    status?: string;

    data?: MeetingExtendedData; // JSON field with extended meeting data

    // Transcript fetching tracking
    transcript_fetch_attempted_at?: string;
    transcript_fetch_status?: TranscriptFetchStatus;

    // Context snapshot tracking
    context_snapshot_status?: ContextSnapshotStatus;

    // AI Processing tracking
    stage0_status?: Stage0Status;
    stage0_attempted_at?: string;
    derived_processing_status?: DerivedProcessingStatus;
    derived_processing_attempted_at?: string;
    tasks_draft_status?: TasksDraftStatus;
    tasks_draft_attempted_at?: string;

    created_at?: string;
    updated_at?: string;

    constructor(init?: Partial<Meeting>) {
      Object.assign(this, init);
    }

    static defaultEmpty(): Meeting {
      return new Meeting({});
    }
  }
  